import { NavigateFunction } from 'react-router-dom';
import dayjs from 'dayjs';

export const getFormattedUserName = (
  userName: string | null | undefined
) => {
  const userNameArray = userName
    ?.split('/')?.[0]
    .split(' ');
  const length = userNameArray?.length;

  if (!length || !userNameArray[0].length) {
    return undefined;
  } else {
    let name = userNameArray[0];
    let shortName = name[0];
    const lastName = userNameArray[length - 1];
    if (length > 1 && !!lastName.length) {
      name = name + ' ' + lastName;
      shortName = shortName + lastName[0];
    }
    return { name, shortName };
  }
};

export const updateQueryParams = (
  newParams: object,
  navigate: NavigateFunction
) => {
  const queryParams = new URLSearchParams(
    window.location.search
  );
  for (const [key, value] of Object.entries(newParams)) {
    if (value === undefined || value === null) {
      queryParams.delete(key);
    } else {
      queryParams.set(key, value);
    }
  }
  navigate(`?${queryParams.toString()}`);
};

export const tokenExpiringInMs = (
  token: string | undefined,
  timeInMs: number
) => {
  if (!token) return true;
  const expiry = JSON.parse(atob(token.split('.')[1])).exp;
  return dayjs.unix(expiry).diff(dayjs()) < timeInMs;
};
